import React from 'react'

const viewportContext = React.createContext({});

export { viewportContext }

// Check './viewport-provider' for viewport handler